import { ref } from "vue";

// Single source of truth for the slideover width — `MyTasksSlideoverPanel`
// applies it as `w-[<n>px]`, and `CustomizeDashboard` uses it to lay out
// the floating button column to the panel's left.
export const MY_TASKS_PANEL_WIDTH = 448;

const isOpen = ref(false);
const hasLocalButton = ref(false);
const panelWidth = ref(MY_TASKS_PANEL_WIDTH);
// Mirrored from useAIChatSlideover / useWidgetsSlideover so the
// dashboard's floating-button v-show guard can hide the buttons during
// a resize drag of THIS panel too — without the flag, the global guard
// only covered AI chat and Widgets, and the My Tasks resize was visibly
// laggy because the buttons stayed mounted and re-laid-out every frame.
const isResizing = ref(false);

export function useMyTasksSlideover() {
  function toggle(): void {
    isOpen.value = !isOpen.value;
  }

  function open(): void {
    isOpen.value = true;
  }

  function close(): void {
    isOpen.value = false;
  }

  return {
    isOpen,
    hasLocalButton,
    panelWidth,
    isResizing,
    toggle,
    open,
    close,
  };
}

// Reset every module-level ref to its default. Called on logout / org
// switch so a re-login doesn't see the previous user's panel state
// (open flag, local-button toggle, panel width override).
export function resetMyTasksState(): void {
  isOpen.value = false;
  hasLocalButton.value = false;
  panelWidth.value = MY_TASKS_PANEL_WIDTH;
  isResizing.value = false;
}
